import React from "react";
import Environment from "../../Images/OurWork/Environment.png";
const EnvironmentSustainability = () => {
  return (
    <div>
      <img src={Environment} />
    </div>
  );
};

export default EnvironmentSustainability;
